import React from "react";
import styles from "./initial-structure-panel-control-bar.module.scss";
import { FilterIcon } from "@src/components/molecules/filter-icon/filter-icon";
import { useFilterIconNewInitialStructureHook } from "../filter-icon/use-filter-icon-new-initial-structure-hook";
import { NodesCounterSelector } from "../nodes-counter-selector/nodes-counter-selector";

const cssClassName = "initial-structure-panel-control-bar";

export const InitialStructurePanelControlBar = () => {
  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__buttons-wrapper`]}>
        <FilterIcon useHook={useFilterIconNewInitialStructureHook} />
      </div>
      <NodesCounterSelector structure="initial" />
    </div>
  );
};
